import React, { useEffect, useState } from 'react'
import { useTicketGroups } from 'pages/store'
import { Pagination } from 'antd'
import moment from 'moment'
import _ from 'lodash'

const TicketGroupLogs = () => {
    const [logs, setLogs] = useState([])
    const [rowCount, setRowCount] = useState(1)
    const { fetchTicketGroupLogs, ticketGroupLogs } = useTicketGroups()
    useEffect(() => {
        fetchTicketGroupLogs(1);
    }, [])
    useEffect(() => {
        const logsData = _.get(ticketGroupLogs, ['result'], [])
        const rows = _.get(ticketGroupLogs, ['rowCount'], 0);
        setLogs(logsData);
        setRowCount(rows);
    }, [ticketGroupLogs])

    const getStatement = (data) => {
        const action = _.get(data, ['action'], '');
        const authorName = _.get(data, ['author', 'first_name'], '');
        const groupName = _.get(data, ['group_id'], '-');
        const updatedAt = moment(_.get(data, ['updatedAt'])).format('llll')
        const subcategory = _.get(data, ['subcategory'], []);
        const subcategories = _.isEmpty(subcategory) ? '' : subcategory.length > 1 ? subcategory.map(subcat => subcat.sub_cat_display_name).join(', ') : subcategory[0].sub_cat_display_name

        const users = _.get(data, ['users'], []);
        let usersString = ''
        if (!_.isEmpty(users)) {
            usersString = users.map(user => `${user.first_name} (${user.email})`).join(', ');
        }
        const authorAdnTimeStamp = <div className='d-flex justify-content-between fw-bold fst-italic mb-1'><p className='text-capitalize text-black pb-0 mb-0' style={{ fontSize: 16 }}>{authorName}</p><p className='fst-italic pb-0 mb-0' style={{ fontSize: 12 }}>{updatedAt}</p></div>
        switch (action) {
            case 'Created and Assigned': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-success'>Assigned </span><span className='text-black'>{groupName}</span> group to Subcategory <span className='text-black'>{subcategories}</span></p>
            </div>
            case 'Created': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-success'>Created </span><span className='text-black'>{groupName}</span> with users <span className='text-black'>{usersString}</span></p>
            </div>
            case 'Deleted': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-danger'>Deleted </span> <span className='text-black'>{groupName}</span> with users <span className='text-black'>{usersString}</span></p>
            </div>
            case 'Removed': if (_.isEmpty(subcategory)) {
                return <div>
                    {authorAdnTimeStamp}
                    <p className='fst-italic pb-0 mb-0'><span className='text-danger'>Removed </span><span className='text-black'>{usersString} </span> from <span className='text-black'>{groupName}</span></p>
                </div>
            } else {
                return <div>
                    {authorAdnTimeStamp}
                    <p className='fst-italic pb-0 mb-0'><span className='text-danger'>Removed </span>subcategory <span className='text-black'>{subcategories}</span> from round robin, <span className='text-black'>{groupName}</span> was assigned to this subcategory</p>
                </div>
            }
            case 'Assigned': if (_.isEmpty(users)) {
                return <div>
                    {authorAdnTimeStamp}
                    <p className='fst-italic pb-0 mb-0'><span className='text-success'>Assigned </span> <span className='text-black'>{groupName}</span> group to <span className='text-black'>{subcategories}</span></p>
                </div>
            }
            else {
                return <div>
                    <span className='text-success'>Assigned </span><span className='text-black'>{groupName}</span> group to <span className='text-black'>{subcategories}</span>
                </div>
            }
            case 'Added': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-success'>Added </span> <span className='text-black'>{usersString} </span> to group <span className='text-black'>{groupName}</span></p>
            </div>
            case 'Inactive': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-danger'>Inactivated </span> <span className='text-black'>{usersString}</span></p>
            </div>
            case 'Active': return <div>
                {authorAdnTimeStamp}
                <p className='fst-italic pb-0 mb-0'><span className='text-warning'>Activated </span> <span className='text-black'>{usersString}</span></p>
            </div>
        }
    }
    const logList = logs.map((log) => {
        return getStatement(log)
    })

    return (
        <>
            <div style={{ height: '70vh' }} className='overflow-scroll scrollable-container'>
                {
                    logList.map((log) => <div className='border border-1 shadow-md p-2 mx-2 my-3 rounded'>
                        <p className='p-0 m-0 fs-1'>{log}</p>
                    </div>
                    )
                }
            </div>
            <div className='d-flex w-100 justify-content-center py-3'>
                <Pagination defaultCurrent={1} total={rowCount} onChange={(page) => { fetchTicketGroupLogs(page) }} />
            </div>
        </>
    )
}

export default TicketGroupLogs